<template>
	<div>
		<group-invite-dialog
			ref="group-invite-dialog"
			:group="group"
		/>
		<div class="d-flex">
			<div>
				<avatar @click.native="$emit('input', 'base')" class="cursor-pointer" :group="group" xxl/>
			</div>
			<div class="pl-5 pt-7 flex-grow-1" style="z-index: 1">
				<div
					@click="$emit('input', 'base')"
					class="font-20 font-weight-bold mb-1 white--text cursor-pointer"
				>
					{{ group.name }}
				</div>
				<div
					class="mb-5 white--text cursor-pointer"
					@click="$emit('input', 'base')"
				>
					{{ group.users_count }} członków
				</div>
				<div class="d-flex justify-content-between">
					<v-btn
						:ripple="false"
						color="white"
						elevation="0"
						class="grey--text mr-3 px-0 py-0"
						style="pointer-events: none"
					>
						<template v-if="group.is_public">
							<v-icon class="font-14 mr-2">mdi-web</v-icon> Publiczna
						</template>
						<template v-else>
							<v-icon class="font-14 mr-2">$ban</v-icon> Prywatna
						</template>
					</v-btn>
					<div>
						<v-btn
							color="accent lighten-2"
							elevation="0"
							class="accent--text mr-2"
							v-if="!group.permissions.status && group.permissions.can_join"
							@click="requestToJoinGroup({ group })"
						>
							<template v-if="group.is_public">
								<v-icon class="font-14 mr-2">mdi-plus</v-icon> Dołącz do grupy
							</template>
							<template v-else>
								Wyślij prośbę o dołączenie do grupy
							</template>
						</v-btn>
						<v-menu
							bottom
							min-width="200px"
							rounded
							offset-y
							left
						>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									color="grey lighten-2"
									class="grey--text text--darken-1"
									elevation="0"
								>
									Więcej<v-icon class="ml-1">mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<v-card class="d-flex flex-column py-2">
								<template v-for="(option, i) in options">
									<post-dropdown-button
										v-if="option.display"
										:text="option.text"
										:icon="option.icon"
										:action="option.action"
										v-bind:key="'filter-' + i"
									/>
								</template>
							</v-card>
						</v-menu>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import {mapActions} from "vuex";
import PostDropdownButton from "@/components/wall/post/PostDropdownButton";
import GroupInviteDialog from "@/components/group/GroupInviteDialog";
export default {
	name: "GroupHeader",
	components: {
		Avatar,
		PostDropdownButton,
		GroupInviteDialog,
	},
	props: {
		group: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			options: [
				{
					text: this.$vuetify.lang.t('$vuetify.views.group.options.invite'),
					type: 'invite',
					icon: null,
					display: true,
					action: async () => {
						await this.getUsersToInvite({ group : this.group })
						this.$refs['group-invite-dialog'].showDialog()
					}
				},
				{
					text: this.$vuetify.lang.t('$vuetify.views.group.options.members'),
					type: 'members',
					icon: null,
					display: true,
					action: () => {
						this.$emit('input', 'members')
					}
				},
				{
					text: this.$vuetify.lang.t('$vuetify.views.group.options.settings'),
					type: 'settings',
					icon: null,
					display: true,
					action: () => {
						this.$emit('input', 'settings')
					}
				},
				{
					text: this.$vuetify.lang.t('$vuetify.views.group.options.leave'),
					type: 'leave',
					icon: null,
					display: true,
					action: async () => {
						if (await this.leaveGroup({ id: this.group.id })) {
							// this.$route.push({ name: 'Groups' })
						}
					}
				},
			]
		}
	},
	watch: {
		'group.permissions': {
			handler() {
				this.checkEditAbility()
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		...mapActions('groups', [
			'requestToJoinGroup',
			'getUsersToInvite',
			'leaveGroup'
		]),
		checkEditAbility() {
			let editable = this.group.permissions.status === 'accepted'
			for (let i in this.options) {
				let type = this.options[i].type
				if (type === 'invite' || type === 'leave') {
					this.options[i].display = editable
				} else if (type === 'settings') {
					this.options[i].display = (editable && (this.group.permissions.my_role === 'moderator' || this.group.permissions.my_role === 'owner'))
				}
			}
		}
	}
}
</script>
